import { useStores } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { Button, XStack } from '@/components/ui';
import { cn } from '@/lib/utils';
import { uiStore } from '@/stores/ui.store';

import { messageGroupOf } from './hivemind-conversations-status';
import { useHivemindSendAll } from './use-hivemind-send-all';

/** The one action a chat's cards share: sending several drafts, each its own card, at once. With none, nothing is drawn */
export const HivemindBanner = observer(function HivemindBanner({
  threadId,
  inPanel = false,
}: {
  readonly threadId: string;
  readonly inPanel?: boolean;
}) {
  const { draftCount, isSending, sendAll } = useHivemindSendAll(threadId);
  const chatCards = useStores().actionCards.getByChatId(threadId);
  // A message to several people has its own card, which holds the people, the count and the answers
  if (
    draftCount < 2 ||
    chatCards.some((card) => messageGroupOf(card, chatCards).length > 1)
  )
    return null;

  return (
    <XStack
      className={cn(
        'w-full items-center justify-end self-center px-4 pb-1 pt-3',
        !inPanel && ['md:px-12', uiStore.chatWidth]
      )}
    >
      <Button size="sm" disabled={isSending} onClick={sendAll}>
        {isSending ? 'Sending…' : `Send all ${draftCount}`}
      </Button>
    </XStack>
  );
});
